<template>
<div class="related-chart-group-wrapper">
  <div v-if="showHeader" class="related-chart-group-header">
    <span>{{dataConfig.name}}</span>
  </div>

  <div class="related-chart-group-body">
    <div v-for="(data, index) in dataGroup" :key="index">
      <related-chart
        :base-data="data[0]"
        :related-data="data[1]"
        :audit-rule-map="auditRuleFlagMap"
      />
    </div>
  </div>
</div>
</template>

<script>
import RelatedChart from '../../../../../components/Data/RelatedChart'

export default {
  name: 'RelatedChartGroup',
  components: {RelatedChart},
  props: {
    dataConfig: {
      required: true,
      type: Object
    },
    relatedOpts: {
      required: true,
      type: Array
    },
    unitProp: {
      required: true,
      type: String
    },
    auditRuleFlagMap: {
      type: Object
    },
    showHeader: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    dataGroup: Object.freeze([])
  }),
  watch: {
    dataConfig: {
      immediate: true,
      handler (dataConfig) {
        let dimensionMap = dataConfig.dimensions.reduce((map, dimension) => {
          map[dimension.id] = dimension
          return map
        }, {})
        let {dataTimes, seriesMap} = dataConfig
        let {unitProp} = this

        this.dataGroup = Object.freeze(this.relatedOpts.map(({id1, id2, relatedLow, relatedHigh}) => [id1, id2].map(dimensionId => {
          let dimension = dimensionMap[dimensionId]
          let series = seriesMap[dimensionId]

          return {
            id: dimensionId,
            name: dimension.name,
            unit: dimension[unitProp],
            relatedLow,
            relatedHigh,
            data: dataTimes.map(dataTimeObj => {
              let dataTime = dataTimeObj[1]
              let data = series[dataTime]
              return data || {
                dataTime,
                value: null
              }
            })
          }
        })))
      }
    }
  }
}
</script>

<style lang="scss">
.related-chart-group-wrapper {
  > .related-chart-group-header {
    display: grid;
    grid-template-columns: auto max-content;
    line-height: 1.8em;
    padding: 0 10px;
    color: #ffffff;
    background: linear-gradient(to right, #fbc15a 0%, #fff 100%);
    font-weight: 600;
  }

  > .related-chart-group-body {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    padding: 12px 0;

    > div {
      flex: 0 0 400px;
      height: 400px;
      min-width: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/01Photochemical/00VOCs/05Heterogeneous/RelatedChartGroup.vue